import * as React from "react";

import { UitkLayoutFlex, UitkLayoutFlexItem } from "@egds/react-core/layout-flex";
import { UitkSpacing, UitkSpacingSpaces } from "@egds/react-core/spacing";
import { UitkHeading } from "@egds/react-core/text";

import type { FlightsLink } from "typings/microserviceModels/flights-flex-module";

import { AirlineLogo } from "./AirlineLogo";
import { FlightLegDetails } from "./FlightLegDetails";

interface FlightLegProps {
  airCarrier: string;
  airCarrierEBF: string;
  flight: FlightsLink;
  isMobile: boolean;
  isOneWay: boolean;
  isOutBound: boolean;
  showCityName: boolean;
}

export const FlightLeg: React.FC<FlightLegProps> = ({
  airCarrier,
  airCarrierEBF,
  flight,
  isMobile,
  isOneWay,
  isOutBound,
  showCityName,
}) => {
  const { airCarrierImageUrl, formattedDepartureDate, formattedReturnDate, inboundAirCarrierImageUrl } = flight;

  const formattedDate = isOutBound ? formattedDepartureDate : formattedReturnDate;
  const logoUrl = isOutBound ? airCarrierImageUrl : inboundAirCarrierImageUrl;

  const margin: UitkSpacingSpaces | undefined = !isOneWay && !isOutBound ? { blockstart: "four" } : undefined;
  const padding: UitkSpacingSpaces | undefined = isOneWay ? { block: isMobile ? "six" : "eight" } : undefined;

  return (
    <UitkSpacing margin={margin} padding={padding}>
      <UitkLayoutFlexItem>
        <UitkLayoutFlex direction="row" alignItems="center" justifyContent="space-between">
          <UitkLayoutFlexItem grow={1}>
            <UitkLayoutFlex>
              <AirlineLogo isMobile={isMobile} logoAlt={airCarrier} logoUrl={logoUrl} />
              <FlightLegDetails
                flight={flight}
                airCarrierEBF={airCarrierEBF}
                isMobile={isMobile}
                isOutBound={isOutBound}
                showCityName={showCityName}
              />
            </UitkLayoutFlex>
          </UitkLayoutFlexItem>

          <UitkLayoutFlexItem>
            <UitkHeading size={6}>{formattedDate}</UitkHeading>
          </UitkLayoutFlexItem>
        </UitkLayoutFlex>
      </UitkLayoutFlexItem>
    </UitkSpacing>
  );
};
